import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useSelectable } from 'hooks/useSelectable';
import { useUsers } from 'hooks/useUsers';
import { SelectionInfo } from 'components/SelectionInfo';
import { NoResults } from 'components/NoResults';
import { Button } from 'components/Button';
import { Table } from 'components/Table';
import { UserRow } from 'pages/Users/UserRow';
import styles from 'pages/Users/Users.scss';

export const Users = () => {
  const {
    users,
    locations,
    isLoading,
    changedRoles,
    changedLocations,
    handleSaveChanges,
    setChangedRoles,
    setChangedLocations,
    handleDelete,
  } = useUsers();
  const { selectedIDs, toggleSelection, clearSelection } = useSelectable();

  const statuses = useSelector((state) => state.users.statuses);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.titleWrapper}>
          <h1>
            <FontAwesomeIcon icon={faUserTie} />
            Персонал
          </h1>
          <p>Огляд всіх користувачів системи</p>
        </div>
        <div className={styles.buttons}>
          <SelectionInfo
            selectedItems={selectedIDs}
            wordForms={['користувача', 'користувачі', 'користувачів']}
            isSelectionMode={selectedIDs.length > 0}
          />
          <Button
            text='Видалити'
            onClick={() => handleDelete(selectedIDs, clearSelection)}
            ghostStyle
            disabled={selectedIDs.length === 0}
          />
          <Button
            text='Зберегти'
            onClick={handleSaveChanges}
            disabled={!Object.keys(changedRoles).length && !Object.keys(changedLocations).length}
          />
        </div>
      </div>
      {users.length > 0 ? (
        <Table
          columns={[
            { key: 'checkbox', label: '' },
            { key: 'name', label: "Прізвище та ім'я" },
            { key: 'email', label: 'Пошта' },
            {
              key: 'role',
              label: 'Роль',
              info: 'Роль визначає рівень доступу до панелі керування.  \n**Керівник**  \nПризначення ролей персоналу, керування усіма залами та контентом вебсайту.  \n**Адміністратор**  \nКерування призначеною керівником залою.  \n**Переглядач**  \nПерегляд призначеної локації без права створення, редагування та видалення.',
            },
            {
              key: 'location',
              label: 'Локація',
              info: 'Вибрана локація надає адміністратору доступ до керування відповідним залом.  \nПри виборі локації "Філії" надається доступ одразу до усіх залів типу "Філія".  \nЛокації призначаються адміністраторам та переглядачам.',
            },
            {
              key: 'lastSeen',
              label: 'У мережі',
            },
          ]}
          data={users}
          selectedIDs={selectedIDs}
          renderRow={(user, index) => (
            <UserRow
              user={user}
              locations={locations}
              index={index}
              setChangedRoles={setChangedRoles}
              setChangedLocations={setChangedLocations}
              toggleSelection={toggleSelection}
              key={user.id}
              status={statuses[user.id]}
            />
          )}
        />
      ) : (
        !isLoading && <NoResults />
      )}
    </>
  );
};
